exports.Overlay = function () {
  return null;
};